module.exports = __webpack_public_path__ + "static/media/Landing_Page_Line_Dwg_2.f04c0547.png";